import { createSlice } from "@reduxjs/toolkit";

import { TECH_WORKS_MODULE_NAME } from "./constants";

const initialState: Record<string, never> = {};

const techWorksSlice = createSlice({
  name: TECH_WORKS_MODULE_NAME,
  initialState,
  reducers: {},
});

export const techWorksReducer = techWorksSlice.reducer;
